angular.module('picmonicng').filter('floor', function () {
  return function (input) {
    if (input) {
      return Math.floor(input);
    }
  };
});
